export default "__VITE_ASSET__DvMhnOk2__"